<div class="container-fluid">
    <div class="row pt-4 pl-4" style="font-size: 22px !important;
    font-weight: 400;
    color: #424242;">
      <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Manage Article Vacancy
      </h5>
    </div>
  <div id="mainContent" class="container">
    <div class="row pt-3" >
      <div class="col-md-8"></div>
      <div class="col-md-3">
        <button mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add" matTooltipPosition="left"
        (click)="openModal(modalContent,'add')">
            <i class="fa fa-plus-square" aria-hidden="true" style="color:#ffff"></i>&nbsp;&nbsp; Article Vacancy
        </button>
      </div>
    </div>
  <div class="pt-2 pb-2">
    <div class="col-md-12">
      <table class="table table-bordered table-striped table-sm">
        <thead class="">
          <tr>
            <th scope="col">Sr.No.</th>
            <th scope="col">Partner Name</th>
            <th scope="col">Article Eligibility</th>
            <th scope="col">Article Registered</th>
            <th scope="col">Article Vacancy</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody *ngFor="let data of articleVacancyData;let i=index">
          <td>{{i+1}}</td>
          <td>{{data.partner.firstName}} {{data.partner.middleName}} {{data.partner.lastName}}</td>
          <td>{{data.eligibility}}</td>
          <td>{{data.registered}}</td>
          <td>{{data.vacancy}}</td>
          <td>
            <button class="btn btn-sm btn-outline-theme"  (click)="onEditClick(modalContent,data)"
            matTooltip="Click to edit" matTooltipPosition="above">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button> &nbsp;&nbsp;
            <button class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(data)"
            matTooltip="Click to delete" matTooltipPosition="above">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
          </td>
        </tbody>
      </table>
    </div>
  </div>
  </div>
  </div>

  <!-- Modal Template -->
  <ng-template #modalContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
      <h5 class="modal-title" id="modal-basic-title">Article Vacancy</h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="modalForm">
        <div class="row">
          <label class="col-sm-6">Partner Name:</label>
          <div class="col-sm-6">
            <select class="form-control form-control-xs" id="partnerName" name="partnerName" 
            class="form-control form-control-xs"
            formControlName="partnerName" [class.is-invalid]="formErrors.partnerName && formSubmitted"
            matTooltip="{{formErrors.partnerName}}" matTooltipPosition="above">
            <option [value]="null">Select Partner </option>
              <option *ngFor="let partnerName of partnerList" [disabled]="modalStatus=='edit'" [ngValue]="partnerName">{{partnerName.firstName}} {{partnerName.middleName}} {{partnerName.lastName}}</option>
            </select>
          </div>
        </div>

        <!-- <div class="row" *ngIf="modalStatus=='edit';else elseBlock">
            <label class="col-sm-6">Partner Name:</label>
            <div class="col-sm-6">
            <input id="partnerName" name="partnerName" type="text" class="form-control form-control-xs"
            formControlName="partnerName.firstName" [class.is-invalid]="formErrors.partnerName && formSubmitted"
            matTooltip="{{formErrors.partnerName}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
            </div>
          </div> -->

        <div class="row">
          <label class="col-sm-6">Article Eligibility:</label>
          <div class="col-sm-6">
          <input id="articleEligibility" name="articleEligibility" type="number" class="form-control form-control-xs"
          formControlName="articleEligibility" [class.is-invalid]="formErrors.articleEligibility && formSubmitted"
          matTooltip="{{formErrors.articleEligibility}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer" style="">
      <div class="row col-md-12">
          <div class="col-sm-6"></div>
          <div class="col-sm-3">
            <button  type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
            <button  type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
        </div>
          <div class="col-sm-3">
              <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="closeModal()">Close</button>
          </div>
  
      </div>
  </div>
  </ng-template>
  